export type JwtPayload = Record<string, unknown>;

const decodeBase64Url = (input: string): string => {
  const base64 = input.replace(/-/g, '+').replace(/_/g, '/');
  const padded = `${base64}${'='.repeat((4 - (base64.length % 4)) % 4)}`;
  return atob(padded);
};

export const decodeJwtPayload = (token: string): JwtPayload | null => {
  if (!token) {
    return null;
  }

  const segments = token.split('.');
  if (segments.length < 2) {
    return null;
  }

  try {
    const payloadString = decodeBase64Url(segments[1]);
    const payload = JSON.parse(payloadString) as JwtPayload;
    return payload;
  } catch {
    return null;
  }
};

export const isJwtExpiredOrInvalid = (token: string, clockSkewMs = 30_000): boolean => {
  const payload = decodeJwtPayload(token);
  const expiresAtSeconds = payload?.exp;

  if (typeof expiresAtSeconds !== 'number' || !Number.isFinite(expiresAtSeconds)) {
    return true;
  }

  return expiresAtSeconds * 1000 <= Date.now() + Math.max(0, clockSkewMs);
};
